import React from "react"
import Relay from "react-relay"
import { find } from "lodash/collection"
import classNames from "classnames"
import { licenseTypes } from "../../scripts/licenseTypes"
import { messages as licenseMessages } from "../../messages/licenses"
import { messages as listMessages } from "../../messages/lists"
import settingsMessages from "../../messages/settings"
import { injectIntl } from "react-intl"
import { getAccountSettings } from "../../scripts/accountSettings"

class ResourceAttribution extends React.Component {
  render() {
    // sharing/attribution license display
    const { title, intl, resource, className, file } = this.props
    const { license: licenseProp, date_humanized, rightsholder } = JSON.parse(
      resource.custom_fields
    )

    if (!resource) {
      return <div />
    }

    const license = find(licenseTypes, {
      name: licenseProp ? licenseProp.value : ""
    })

    const {
      settings: { contact_email }
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const licenseText =
      license && license.label in licenseMessages
        ? intl.formatMessage(licenseMessages[license.label], {
            email: contact_email
          })
        : ""

    const attribution =
      title === "default"
        ? `${intl.formatMessage(licenseMessages.fullCredit)} ${
            file ? file.type : resource.type
          }`
        : title

    return (
      <div className={classNames("attribution", className)}>
        {title && <h4 className="mbt bold">{attribution}</h4>}
        <span className="attribution__title">{resource.title}</span>
        <span className="attribution__creator">
          {" "}
          &ndash;&nbsp;
          {resource.creator && resource.creator}
          {!resource.creator && "Unknown"}
        </span>
        <br />
        {date_humanized && (
          <span className="attribution__date">{date_humanized.value}, </span>
        )}
        <span className="attribution__license">{licenseText}</span>
        {rightsholder &&
          resource.license != "no_known_restrictions" && (
            <span className="attribution__rightsholder">
              , {rightsholder.value}
            </span>
          )}
      </div>
    )
  }
}

export default Relay.createContainer(injectIntl(ResourceAttribution), {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        title
        custom_fields
        type
        creator
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/ResourceAttribution.js